var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 66 66",
    viewBox: "0 0 66 66",
    id: "Finance",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.412,
    height: 3.583,
    x: 1.33,
    y: 61.417,
    fill: "#e4e4e4",
    className: "colore4e4e4 svgShape"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.412,
    height: 3.583,
    x: 3.358,
    y: 57.834,
    fill: "#e4e4e4",
    className: "colore4e4e4 svgShape"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10.412,
    height: 3.583,
    x: 1.33,
    y: 54.251,
    fill: "#e4e4e4",
    className: "colore4e4e4 svgShape"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10.412,
    height: 3.583,
    x: 3.358,
    y: 50.668,
    fill: "#e4e4e4",
    className: "colore4e4e4 svgShape"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 10.412,
    height: 3.583,
    x: 1.33,
    y: 47.085,
    fill: "#e4e4e4",
    className: "colore4e4e4 svgShape"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 10.412,
    height: 3.583,
    x: 3.358,
    y: 43.502,
    fill: "#e4e4e4",
    className: "colore4e4e4 svgShape"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 10.412,
    height: 3.583,
    x: 16.732,
    y: 61.417,
    fill: "#e4e4e4",
    className: "colore4e4e4 svgShape"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 10.412,
    height: 3.583,
    x: 18.76,
    y: 57.834,
    fill: "#e4e4e4",
    className: "colore4e4e4 svgShape"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 10.412,
    height: 3.583,
    x: 16.732,
    y: 54.251,
    fill: "#e4e4e4",
    className: "colore4e4e4 svgShape"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 10.412,
    height: 3.583,
    x: 18.76,
    y: 50.668,
    fill: "#e4e4e4",
    className: "colore4e4e4 svgShape"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 28.435,
    height: 34.511,
    x: 36.235,
    y: 30.489,
    fill: "#e2e7e7",
    className: "colore2e3e7 svgShape"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 23.099,
    height: 6.043,
    x: 38.904,
    y: 33.151,
    fill: "#1ce8f8",
    className: "colorf89c1c svgShape"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 4.375,
    height: 4.375,
    x: 40.128,
    y: 42.224,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 4.375,
    height: 4.375,
    x: 48.266,
    y: 42.224,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 4.375,
    height: 4.375,
    x: 56.403,
    y: 42.224,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 4.375,
    height: 4.375,
    x: 40.128,
    y: 49.832,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 4.375,
    height: 4.375,
    x: 48.266,
    y: 49.832,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 4.375,
    height: 4.375,
    x: 40.128,
    y: 57.439,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 4.375,
    height: 4.375,
    x: 48.266,
    y: 57.439,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 4.375,
    height: 12.12,
    x: 56.403,
    y: 49.694,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M16.41982,18.2524V6.5725c1.50288,0,2.72118-1.2184,2.72118-2.7212h33.0604 c0,1.5028,1.21842,2.7212,2.7212,2.7212v11.6799c-1.50278,0-2.7212,1.2184-2.7212,2.72119H19.141 C19.141,19.4708,17.9227,18.2524,16.41982,18.2524z",
    className: "color459fd8 svgShape"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.671,
    cy: 12.412,
    fill: "#ffffff",
    rx: 6.375,
    ry: 8.561,
    className: "colorffffff svgShape"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.546,
    cy: 12.412,
    r: 2.234,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48.797,
    cy: 12.412,
    r: 2.234,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#185054",
    d: "M13.769 43.002H3.3579c-.2764 0-.5.22359-.5.5v3.083H1.3296c-.2764 0-.5.22359-.5.5v3.583c0 .2764.2236.5.5.5h1.5283v2.583H1.3296c-.2764 0-.5.22359-.5.5v3.583c0 .2764.2236.5.5.5h1.5283v2.583H1.3296c-.2764 0-.5.22359-.5.5V65c0 .2764.2236.5.5.5h10.4121c.2763 0 .5-.2236.5-.5v-3.083h1.5273c.2764 0 .5-.2236.5-.5v-3.583c0-.27641-.2236-.5-.5-.5h-1.5273v-2.583h1.5273c.2764 0 .5-.2236.5-.5v-3.583c0-.27641-.2236-.5-.5-.5h-1.5273v-2.583h1.5273c.2764 0 .5-.2236.5-.5v-3.583C14.269 43.22559 14.0454 43.002 13.769 43.002zM11.2417 64.5H1.8296v-2.583c.2623 0 9.5336 0 9.4121 0V64.5zM13.269 60.917c-.2623 0-9.5326 0-9.4111 0v-2.583c.2623 0 9.8037 0 9.4111 0V60.917zM11.2417 57.334c-.2624 0-9.8047 0-9.4121 0v-2.583c.2623 0 9.5336 0 9.4121 0V57.334zM13.269 53.751c-.2623 0-9.5326 0-9.4111 0v-2.583c.2623 0 9.8037 0 9.4111 0V53.751zM11.2417 50.168c-.2624 0-9.8047 0-9.4121 0v-2.583c.2623 0 9.5336 0 9.4121 0V50.168zM13.269 46.585h-1.5273H3.8579v-2.583h9.4111V46.585zM29.1723 50.168H18.7602c-.2763 0-.5.22359-.5.5v3.083h-1.5283c-.2764 0-.5.22359-.5.5v3.583c0 .2764.2236.5.5.5h1.5283v2.583h-1.5283c-.2764 0-.5.22359-.5.5V65c0 .2764.2236.5.5.5H27.144c.2764 0 .5-.2236.5-.5v-3.083h1.5283c.2764 0 .5-.2236.5-.5v-3.583c0-.27641-.2236-.5-.5-.5H27.644v-2.583h1.5283c.2764 0 .5-.2236.5-.5v-3.583C29.6723 50.39159 29.4487 50.168 29.1723 50.168zM26.644 64.5h-9.4121v-2.583c.2623 0 9.5336 0 9.4121 0V64.5zM28.6723 60.917c-.2623 0-9.5336 0-9.4121 0v-2.583c.2624 0 9.8047 0 9.4121 0V60.917zM26.644 57.334c-.2623 0-9.8046 0-9.4121 0v-2.583c.2623 0 9.5336 0 9.4121 0V57.334zM28.6723 53.751c-.2623 0-9.5336 0-9.4121 0v-2.583h9.4121V53.751zM64.6704 29.9893H36.23582c-.27642 0-.5.2236-.5.5V65c0 .2764.22358.5.5.5H64.6704c.2763 0 .5-.2236.5-.5V30.4893C65.1704 30.2129 64.9467 29.9893 64.6704 29.9893zM64.1704 64.5H36.73582V30.9893H64.1704V64.5z",
    className: "color2f1854 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185054",
    d: "M40.1284 47.0987h4.375c.27642 0 .5-.2237.5-.5v-4.375c0-.2764-.22358-.5-.5-.5h-4.375c-.2764 0-.5.2236-.5.5v4.375C39.6284 46.875 39.852 47.0987 40.1284 47.0987zM40.6284 42.7237h3.375v3.375h-3.375V42.7237zM48.2651 47.0987h4.375c.2764 0 .5-.2237.5-.5v-4.375c0-.2764-.2236-.5-.5-.5h-4.375c-.2764 0-.5.2236-.5.5v4.375C47.7651 46.875 47.9887 47.0987 48.2651 47.0987zM48.7651 42.7237h3.375v3.375h-3.375V42.7237zM56.40282 47.0987h4.375c.27638 0 .5-.2237.5-.5v-4.375c0-.2764-.22362-.5-.5-.5h-4.375c-.27642 0-.5.2236-.5.5v4.375C55.90282 46.875 56.1264 47.0987 56.40282 47.0987zM56.90282 42.7237h3.375v3.375h-3.375V42.7237zM40.1284 54.7071h4.375c.27642 0 .5-.2237.5-.5v-4.375c0-.2764-.22358-.5-.5-.5h-4.375c-.2764 0-.5.2236-.5.5v4.375C39.6284 54.4834 39.852 54.7071 40.1284 54.7071zM40.6284 50.3321h3.375v3.375h-3.375V50.3321zM48.2651 54.7071h4.375c.2764 0 .5-.2237.5-.5v-4.375c0-.2764-.2236-.5-.5-.5h-4.375c-.2764 0-.5.2236-.5.5v4.375C47.7651 54.4834 47.9887 54.7071 48.2651 54.7071zM48.7651 50.3321h3.375v3.375h-3.375V50.3321zM40.1284 62.3145h4.375c.27642 0 .5-.2237.5-.5v-4.375c0-.2764-.22358-.5-.5-.5h-4.375c-.2764 0-.5.2236-.5.5v4.375C39.6284 62.0908 39.852 62.3145 40.1284 62.3145zM40.6284 57.9395h3.375v3.375h-3.375V57.9395zM48.2651 62.3145h4.375c.2764 0 .5-.2237.5-.5v-4.375c0-.2764-.2236-.5-.5-.5h-4.375c-.2764 0-.5.2236-.5.5v4.375C47.7651 62.0908 47.9887 62.3145 48.2651 62.3145zM48.7651 57.9395h3.375v3.375h-3.375V57.9395zM56.40282 62.3145h4.375c.27638 0 .5-.2237.5-.5V49.6944c0-.2764-.22362-.5-.5-.5h-4.375c-.27642 0-.5.2236-.5.5v12.1201C55.90282 62.0908 56.1264 62.3145 56.40282 62.3145zM56.90282 50.1944h3.375v11.1201h-3.375V50.1944zM13.56782 24.3242H57.7729c.2764 0 .5-.22361.5-.5V1c0-.2763-.2236-.5-.5-.5H13.56782c-.27632 0-.5.2237-.5.5v22.8242C13.06782 24.10059 13.2915 24.3242 13.56782 24.3242zM14.06782 1.5H57.2729v21.8242H14.06782V1.5z",
    className: "color2f1854 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#185054",
    d: "M35.6714 9.1035c.77442 0 1.4043.6299 1.4043 1.4043 0 .2764.2236.5.5.5.2763 0 .5-.2236.5-.5 0-1.1545-.8178-2.1196-1.9043-2.3504V7.1758c0-.2764-.2237-.5-.5-.5-.2764 0-.5.2236-.5.5v.9816c-1.08658.2308-1.9043 1.1959-1.9043 2.3504 0 1.3262 1.0781 2.4043 2.4043 2.4043.77442 0 1.4043.6299 1.4043 1.4043s-.62988 1.4043-1.4043 1.4043c-.7745 0-1.4043-.6299-1.4043-1.4043 0-.2763-.2237-.5-.5-.5-.2764 0-.5.2237-.5.5 0 1.1546.81772 2.1197 1.9043 2.3505v.9825c0 .2764.2236.5.5.5.2763 0 .5-.2236.5-.5v-.9825c1.0865-.2308 1.9043-1.1959 1.9043-2.3505 0-1.3261-1.0782-2.4043-2.4043-2.4043-.7745 0-1.4043-.6299-1.4043-1.4043C34.2671 9.7334 34.8969 9.1035 35.6714 9.1035zM29.1723 27.6895c-1.10248 0-2 .8974-2 2 0 .342.0944.6593.2464.9413l-6.1654 5.7231c-.3333-.2484-.7419-.4008-1.1884-.4008-.35608 0-.686.1014-.9759.2653l-4.0567-4.9489c.2407-.3302.3871-.733.3871-1.1718 0-1.1026-.8975-2-2-2s-2 .8974-2 2c0 .2934.0673.5702.1813.8215l-5.7512 4.6691c-.3218-.2212-.7103-.3519-1.1293-.3519-1.1026 0-2 .8974-2 2 0 1.1025.8974 2 2 2 1.1025 0 2-.8975 2-2 0-.3213-.0833-.6207-.2185-.89l5.7282-4.6505c.3334.249.7424.4018 1.1895.4018.3013 0 .5842-.0719.8408-.1918l4.10462 5.0075c-.18662.304-.29992.6578-.29992 1.0397 0 1.1026.8975 2 2 2 1.1026 0 2-.8974 2-2 0-.2932-.0672-.5699-.18108-.8211l6.20938-5.7639c.3119.2014.6811.3214 1.0791.3214 1.1026 0 2-.8975 2-2C31.1723 28.5869 30.2749 27.6895 29.1723 27.6895zM4.7202 38.2364c-.5518 0-1-.4483-1-1 0-.55181.4482-1 1-1 .2728 0 .5192.1108.6998.28819.0085.01281.011.02771.0209.03991.0058.00709.0147.0095.0208.0162.1559.1764.2585.402.2585.6557C5.7202 37.7881 5.2719 38.2364 4.7202 38.2364zM12.4194 30.0977c0-.5518.4482-1 1-1 .5518 0 1 .4482 1 1 0 .5517-.4482 1-1 1C12.8676 31.0977 12.4194 30.6494 12.4194 30.0977zM20.0649 38.9531c-.5517 0-1-.4482-1-1 0-.5517.4483-1 1-1 .5518 0 1 .4483 1 1C21.0649 38.5049 20.6167 38.9531 20.0649 38.9531zM29.1723 30.6895c-.5517 0-1-.4483-1-1 0-.5518.4483-1 1-1 .5518 0 1 .4482 1 1C30.1723 30.2412 29.7241 30.6895 29.1723 30.6895z",
    className: "color2f1854 svgShape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.a73a2b53148e9490322bbf6ddb896fc8.svg";
export { ForwardRef as ReactComponent };